import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-queue-container',
  templateUrl: './queue-container.component.html',
  styleUrls: ['./queue-container.component.scss']
})
export class QueueContainerComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
